import {QueryState} from '../../../../../_dashboard/helpers'

const USER_SORT_FIELD: Record<string, string> = {
  name: 'firstName',
  email: 'email',
  role: 'role',
  status: 'status',
  lastConnection: 'lastConnection',
}

export function buildUserApiQuery(
  state: QueryState,
  extra: Record<string, unknown> = {},
): Record<string, unknown> {
  const {sort: sortCol, order, ...rest} = state as QueryState & {
    sort?: string
    order?: 'asc' | 'desc'
  }

  const params: Record<string, unknown> = {
    ...rest,
    ...extra,
  }

  if (sortCol && order) {
    const field = USER_SORT_FIELD[sortCol] ?? sortCol.replace(/^-/, '')
    params.sort = order === 'desc' ? (field.startsWith('-') ? field : `-${field}`) : field.replace(/^-/, '')
  }

  return params
}
